import { ApiError } from "@/api/http"

export function formatApiKeyError(error: unknown, fallback: string) {
  if (error instanceof ApiError) {
    const code = error.code ?? `Error ${error.status}`
    const message = error.message?.trim() ? error.message : fallback

    return `${code}: ${message}`
  }

  return fallback
}

export { ApiError }
